module.exports = __webpack_public_path__ + "img/cornerLeftBottom.9e07124e.svg";